export default __webpack_public_path__ + "static/media/headset.ace8fcd7.svg";